import React, { type MouseEvent } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { SLACK_APP_TYPE, type AppType } from '../../../../common/constants';
import messages from './messages';

type Props = {
	onConnectWorkspaceButtonClick?: (e: MouseEvent, analyticsEvent: UIAnalyticsEvent) => void;
	appType: AppType;
};

export const SlackWorkspaceSettingsTitle = ({ appType }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={ConnectedWorkspacesTitle}>
			{appType === SLACK_APP_TYPE
				? formatMessage(messages.slackWorkspaceConnectionsHeading)
				: formatMessage(messages.msTeamsWorkspaceConnectionsHeading)}
		</Box>
	);
};

const ConnectedWorkspacesTitle = xcss({
	color: 'color.text.subtle',
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	fontWeight: '500',
});
